import React from "react";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Required from "./Required";

const DateComponent = ({placeholder, title, name, register, watch, trigger, errors, setValue, required,error,disabled }) => {
  // Convert DD/MM/YYYY string to Date object
  const parseDdMmYyyyToDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  // Format Date object to DD/MM/YYYY
  const formatDateToDdMmYyyy = (dateObj) => {
    if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Watch form value
  // const selectedDate = parseDdMmYyyyToDate(watch(name));

  return (
    <div className="form-group">
      <Label className="from-label" htmlFor={name}>
        {title} {required && <Required />}
      </Label>

      <div className="form-control-wrap">
        <DatePicker
        disabled={disabled}
          id={name}
            className={`form-control ${error ? "is-invalid" : ""}`}
          placeholderText={placeholder}
          selected={watch(name)}
          onChange={(date) => { 
            setValue(name, date); // store in DD/MM/YYYY format
            trigger(name);
          }}
           dateFormat="h:mm aa" 
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Time"
        />

        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default DateComponent;
